export default __webpack_public_path__ + "manualtest1.b28e982d.png";